const PasswordReset = require("./containers/PasswordReset");

module.exports = {
    path: "/password-reset/:token",
    component: PasswordReset,
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/password-reset/index.js